import { ActionList, ActionMenu } from "@primer/react";
import { ChevronDownIcon } from "@primer/octicons-react";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { truongApi } from "../../api/truongApi";
import { useCommonContext } from "../../contexts/common";
import { ITruong } from "../../models/response/truong/ITruong";
import { RootState } from "../../state/reducers";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";

export type ComboboxTruongProps = {
  isReadonly?: boolean;
  value?: number;
  onValueChanged: (id: number) => void;
  className?: string;
  isShowClearButton?: boolean;
  preText?: string;
  stylingMode?: "outlined" | "filled" | "underlined";
  size?: "small" | "medium" | "large";
};

const ComboboxTruong = (props: ComboboxTruongProps) => {
  const [dm_truongs, setDmTruongs] = useState<ITruong[]>([]);
  const [allTruongs, setAllTruongs] = useState<ITruong[]>([]); // toàn bộ, không lọc
  const { translate } = useCommonContext();
  const { language } = useSelector((x: RootState) => x.common);
  const { dm_coso_id } = useCommonSelectedHook();

  const handleReloadAsync = async () => {
    const res = await truongApi.selectAll();
    if (res.is_success) {
      setAllTruongs(res.data);  // lưu toàn bộ
      const filteredData = res.data.filter(
        (truong: ITruong) => truong.dm_coso_id === dm_coso_id
      );
      setDmTruongs(filteredData);
    }
  };

  useEffect(() => {
    handleReloadAsync();
  }, [dm_coso_id]);

  const { value, onValueChanged } = props;

  const selectedData = useMemo(() => {
    if (value && allTruongs.length > 0) {
      // Tìm trong toàn bộ list (không bị filter coso) để edit mode hiển thị đúng
      return allTruongs.find((x) => x.id === value);
    }
    return undefined;
  }, [allTruongs, value]);


  return (
    <div>
      <ActionMenu>
        <ActionMenu.Button
          aria-label="Select school year"
          className="button-left"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
          trailingAction={ChevronDownIcon}
          size={props.size}

        >
          {selectedData
            ? language === "en"
              ? selectedData.ten_truong_en
              : selectedData.ten_truong
            : translate("TruongCombobox.PlaceHolder")}
        </ActionMenu.Button>
        <ActionMenu.Overlay width="small">
          <ActionList selectionVariant="single">
            {props.isShowClearButton && (
              <ActionList.Item
                key={0}
                selected={value !== undefined && 0 === value}
                onSelect={() => {
                  onValueChanged(0);
                }}
              >
                {language === "en" ? "Select" : "Chọn cấp học"}
              </ActionList.Item>
            )}
            {dm_truongs &&
              dm_truongs.map((item) => {
                return (
                  <ActionList.Item
                    key={item.id}
                    selected={value !== undefined && item.id === value}
                    onSelect={() => {
                      onValueChanged(item.id || 0);
                    }}
                  >
                    {language === "en" ? item.ten_truong_en : item.ten_truong}
                  </ActionList.Item>
                );
              })}
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </div>
  );
};

export { ComboboxTruong };
